// extracted by mini-css-extract-plugin
export default {"mainContent":"Main_mainContent__Q4xr+"};